'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Minima = require('../../../Minima');

var _log = require('../../../utility/log');

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activator = function () {
    function Activator() {
        (0, _classCallCheck3.default)(this, Activator);

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.serviceChangedListener = this.serviceChangedListener.bind(this);
        this.extensionChangedListener = this.extensionChangedListener.bind(this);
    }

    /**
     * 插件入口
     * 
     * @param {PluginContext} context 插件上下文
     * @memberof Activator
     */

    /**
     * 插件上下文缓存
     * 
     * @type {PluginContext}
     * @static
     * @memberof Activator
     */


    (0, _createClass3.default)(Activator, [{
        key: 'start',
        value: function start(context) {
            Activator.context = context;
            Activator.context.addServiceChangedListener(this.serviceChangedListener);
            Activator.context.addExtensionChangedListener(this.extensionChangedListener);
            _log2.default.logger.info('INFO: The plugin ' + context.plugin.id + ' is started.');
        }

        /**
         * 服务监听器
         * 
         * @param {string} name 服务名称
         * @param {ServiceAction} action 服务变化活动
         * @memberof Activator
         */

    }, {
        key: 'serviceChangedListener',
        value: function serviceChangedListener(name, action) {
            if (name === 'myService' && action === _Minima.ServiceAction.ADDED) {
                var myService = Activator.context.getDefaultService(name);
                if (myService) {
                    _log2.default.logger.info('Get the myService instance successfully.');
                }
            } else if (action === _Minima.ServiceAction.REMOVED) {
                _log2.default.logger.info('The service ' + name + ' is removed.');
            }
        }

        /**
         * 扩展变更监听器
         * 
         * @param {Extension} extension 扩展对象
         * @param {ExtensionAction} action 扩展对象变化活动
         * @memberof Activator
         */

    }, {
        key: 'extensionChangedListener',
        value: function extensionChangedListener(extension, action) {
            if (action === _Minima.ExtensionAction.ADDED) {
                _log2.default.logger.info('The extension ' + extension.id + ' is added.');
                var extensions = Activator.context.getExtensions('myExtension');
                _log2.default.logger.info('The extension count is ' + extensions.size + '.');
            }

            if (action === _Minima.ExtensionAction.REMOVED) {
                _log2.default.logger.info('The extension ' + extension.id + ' is removed.');
            }
        }

        /**
         * 插件出口
         * 
         * @param {PluginContext} context 插件上下文
         * @memberof Activator
         */

    }, {
        key: 'stop',
        value: function stop(context) {
            Activator.context = null;
            _log2.default.logger.info('INFO: The plugin ' + context.plugin.id + ' is stopped.');
        }
    }]);
    return Activator;
}();

Activator.context = null;
exports.default = Activator;
//# sourceMappingURL=Activator.js.map